import { Link } from 'react-router-dom';

function brandCode(original) {
  return (
    <Link to={`/brands/edit/${original?.id}`}>{original?.brandCode || ''}</Link>
  );
}

function brandName(original) {
  return original?.brandName || '';
}

function isActive(original) {
  return original?.isActive ? 'Active' : 'In-Active';
}

export { brandCode, brandName, isActive };
